import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { Button } from "@mui/material";

// services
import {
  luckyorangeTrackEven,
} from "../../services/lucky-orange/luckyorange-events";
import { useUserContext } from "../../services/context/user-context";
// constants
import { TEXT } from "../../constants/text";
import { ROUTES } from "../../constants/routes";

// svg
import { ReactComponent as IconLocation} from "../../assets/svg/location.svg";
import { ReactComponent as IconSettings} from "../../assets/svg/settings.svg";
import { ReactComponent as IconResults} from "../../assets/svg/regulations.svg";
import { ReactComponent as IconSurvey} from "../../assets/svg/questionnaire.svg";

// style
import { NavContainerShort } from "./nav-header-short.styles";


export const NavHeaderShort = () => {
  const { surveyTallyId } = useUserContext();

  const { projectId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const userToken = searchParams.get("token");

  const pageURL = location.pathname.split("/").pop();

  const handleProjectSetupClick = () => {
    luckyorangeTrackEven("Navbar: open Site Settings");
    navigate(`map/site-settings?token=${userToken}`);
  };

  const handlePlannerClick = () => {
    luckyorangeTrackEven("Navbar: open Master.Maker");
    navigate(`planner?token=${userToken}`);
  };

  const handleResultsClick = () => {
    luckyorangeTrackEven("Navbar: open Results");
    navigate(`map/results?token=${userToken}`);
  };

  const handleSurveyClick = () => {
    luckyorangeTrackEven("Navbar: open Survey");
    navigate(`survey?token=${userToken}`);
  };

  const buttons = [
    {
      key: ROUTES.BUILDING_SETTINGS,
      icon: <IconLocation />,
      label: TEXT.navHeader.siteSettings,
      onClick: handleProjectSetupClick,
    },
    {
      key: ROUTES.PLANNER,
      icon: <IconSettings />,
      label: TEXT.navHeader.masterMaker,
      onClick: handlePlannerClick,
    },
    {
      key: ROUTES.RESULTS,
      icon: <IconResults />,
      label: "Results",
      onClick: handleResultsClick,
    },
    // only include if there is survey
    ...(surveyTallyId
      ? [
          {
            key: ROUTES.RESULTS_SURVEY,
            icon: <IconSurvey />,
            label: "Survey",
            onClick: handleSurveyClick,
          },
        ]
      : []),
  ];

  return (
    <NavContainerShort>
      {buttons.map((btn) => (
        <Button
          key={btn.key}
          onClick={btn.onClick}
          className={`nav-button${pageURL === btn.key ? " selected" : ""}`}
        >
          {btn.icon}
          <span className="nav-text">{btn.label}</span>
        </Button>
      ))}
    </NavContainerShort>
  );
};
